#import "./StaffTrainingPolicyFields.graphql"

mutation AcknowledgeTrainingPolicies($policyIds: [ID!]!) {
  acknowledgeTrainingPolicies(input: { policyIds: $policyIds }) {
    policies {
      ...StaffTrainingPolicyFields
    }
  }
}
